import React, { useState } from 'react';
import { Outlet, NavLink, Link } from 'react-router-dom';
import { useAppSelector } from '../store';
import { IoBusinessOutline, IoPersonOutline, IoMenuOutline, IoHomeOutline } from 'react-icons/io5';
import BrandLogo from '../components/common/BrandLogo';
import BrandGlyph from '../components/common/BrandGlyph';
import Sidebar from '../components/layout/Sidebar';

const MobileLayout: React.FC = () => {
    const { user } = useAppSelector(state => state.auth);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    // Determine the "My Company/Agency" link based on role
    let companyLink = "/dashboard";
    let companyText = "Home";

    if (user?.roles?.includes('agency_owner')) {
        companyLink = "/my-agency";
        companyText = "My Agency";
    } else if (user?.roles?.includes('company_owner')) {
        companyLink = "/my-company";
        companyText = "My Company";
    } else if (user?.roles?.includes('marketing_specialist')) {
        companyLink = "/dashboard";
        companyText = "Dashboard";
    } else if (user?.roles?.includes('admin') || user?.roles?.includes('superadmin')) {
        companyLink = "/companies";
        companyText = "Companies";
    }

    return (
        <div className="mobile-layout">
            {/* Mobile Header - Cleaner */}
            <header className="mobile-header">
                <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="d-flex align-items-center gap-2">
                        <BrandLogo height={24} variant="light" />
                        <span className="badge-beta">Beta</span>
                    </div>
                    <div className="mobile-header-right">
                        <span className="platform-text">No Code <br></br> AI Agent Platform</span>
                    </div>
                </div>
            </header>

            {/* Sidebar (Drawer) - Full screen from right */}
            <Sidebar
                isOpen={sidebarOpen}
                isMobile={true}
                onClose={closeSidebar}
            />

            {/* Main Content */}
            <main className="mobile-content custom-scrollbar">
                <Outlet />
            </main>

            {/* Bottom Navigation - Premium Fixed Style */}
            <nav className="mobile-bottom-nav">
                <NavLink to="/dashboard" onClick={closeSidebar} className={({ isActive }) => `nav-item ${isActive && !sidebarOpen ? 'active' : ''}`}>
                    <div className="icon-wrapper"><IoHomeOutline /></div>
                    <span>Dashboard</span>
                </NavLink>

                <NavLink to={companyLink} onClick={closeSidebar} className={({ isActive }) => `nav-item ${isActive && !sidebarOpen ? 'active' : ''}`}>
                    <div className="icon-wrapper"><IoBusinessOutline /></div>
                    <span>{companyText}</span>
                </NavLink>

                <NavLink to="/ai-chatbots" onClick={closeSidebar} className={({ isActive }) => `nav-item ${isActive && !sidebarOpen ? 'active' : ''}`}>
                    <div className="icon-wrapper">
                        <BrandGlyph size={24} animated={false} />
                    </div>
                    <span>AI Agents</span>
                </NavLink>

                <NavLink to="/profile" onClick={closeSidebar} className={({ isActive }) => `nav-item ${isActive && !sidebarOpen ? 'active' : ''}`}>
                    <div className="icon-wrapper"><IoPersonOutline /></div>
                    <span>Profile</span>
                </NavLink>

                <div
                    className={`nav-item ${sidebarOpen ? 'active' : ''}`}
                    onClick={toggleSidebar}
                    style={{ cursor: 'pointer' }}
                >
                    <div className="icon-wrapper"><IoMenuOutline /></div>
                    <span>Menu</span>
                </div>
            </nav>
        </div>
    );
};

export default MobileLayout;
